const DefaultOrderManagementPanel: React.FC = () => {
  return <></>;
};

export default DefaultOrderManagementPanel;
